import { useCallback } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { datadogRum } from '@datadog/browser-rum';
import logEvent, { LogEvent, LogEventStatus } from 'utils/logEvent';

const useHandleLoginRedirect = () => {
  const { oktaAuth } = useOktaAuth();
  const handleLoginRedirect = useCallback(
    async (username, sessionToken) => {
      // Use the session token to generate ID and access tokens
      const { tokens } = await oktaAuth.token.getWithoutPrompt({
        sessionToken,
        responseType: ['id_token', 'token'],
        scopes: ['openid', 'oneid', 'email', 'profile'],
      });

      // Log successful login
      logEvent(LogEvent.Login, LogEventStatus.Successful, { username });
      datadogRum.addAction('login', { username });

      localStorage.removeItem('attempts');
      await oktaAuth.handleLoginRedirect(tokens);
    },
    [oktaAuth],
  );
  return handleLoginRedirect;
};

export default useHandleLoginRedirect;
